import {JourneyTrack} from '../journey-track';
import {TrackTypes} from '../model/track-types';
import {TrackInfo} from '../model/track-info';
import {TrackActionResult} from "../model/track-action-result";
import { trackDefaultIncomeBasicV2 } from './util/track-default-income-v2';
import { environment } from '../../../../../../environments/environment';
import { DomainOrigin } from '../../../user-signup/model/domain-origin';

export class BasicIncomeTrackV2 extends JourneyTrack {
  readonly originalTracks = [
    ...trackDefaultIncomeBasicV2,
    new TrackInfo('client-data', ['data', 'client-data'], undefined, {dataOrigin: DomainOrigin[environment.registration]}),
    new TrackInfo('broker', ['broker']),
    new TrackInfo('terms', ['terms'], undefined, {dataOrigin: DomainOrigin[environment.registration]})
  ];

  track = [];

  constructor() {
    super();
    this.track = this.originalTracks;
  }

  
  getTrack(): TrackInfo[] {
    return this.track;
  }

  getName(): TrackTypes {
    return TrackTypes.BASIC_V2;
  }

  async loadData(){
    throw new Error('Method not implemented.');
  }

  executeAction(actionName: any, data: any): TrackActionResult {
    throw new Error('Method not implemented.');
  }
  isUncoupled() {
    return false;
  }
  
  isEventComunicator() {
    return false;
  }

  isBackHeader() {
    return false;
  }
}
